import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Field from "@Shared/components/sections/field.vue";
import TextSection from "@Shared/components/sections/text-section.vue";
import SelectSection from "@Shared/components/sections/select-section.vue";
import DateSection from "@Shared/components/sections/date-section.vue";
import { defineComponent, ref, toRefs, computed } from "@vue/composition-api";
import { useI18n } from "vue-i18n-composable";
import InlinePrompt from "@Shared/components/general/inline-prompt.vue";
import moment from "moment";
export default defineComponent({
  name: "CommissionDeduction",
  components: {
    SelectSection,
    TextSection,
    DateSection,
    InlinePrompt,
    Field
  },
  props: {
    deduction: {
      type: Object,
      default: () => ({})
    },
    isReadOnly: {
      type: Boolean,
      required: true
    }
  },
  setup(props, {
    emit
  }) {
    const {
      tc
    } = useI18n();
    const deductionTypeOptions = ref([{
      label: tc("direct-to-lender.commissions.deductions.deductionTypes.officeFees"),
      value: "office-fees"
    }, {
      label: tc("direct-to-lender.commissions.deductions.deductionTypes.creditBureaus"),
      value: "credit-bureaus"
    }, {
      label: tc("direct-to-lender.commissions.deductions.deductionTypes.affiliation"),
      value: "affiliation"
    }, {
      label: tc("direct-to-lender.commissions.deductions.deductionTypes.appraisal"),
      value: "appraisal"
    }, {
      label: tc("direct-to-lender.commissions.deductions.deductionTypes.clientRebate"),
      value: "client-rebate"
    }, {
      label: tc("direct-to-lender.commissions.deductions.deductionTypes.charity"),
      value: "charity"
    }, {
      label: tc("direct-to-lender.commissions.deductions.deductionTypes.royaltyFees"),
      value: "royalty-fees"
    }, {
      label: tc("direct-to-lender.commissions.deductions.deductionTypes.other"),
      value: "other"
    }]);
    const fundsReceivedDateMax = ref(moment().add(1, "days").format());
    const {
      deduction
    } = toRefs(props);
    const computedType = computed({
      get() {
        return deduction.value.type;
      },
      set(value) {
        emit("save", _objectSpread(_objectSpread({}, deduction.value), {}, {
          type: value
        }));
      }
    });
    const computedAmount = computed({
      get() {
        return deduction.value.amount;
      },
      set(value) {
        emit("save", _objectSpread(_objectSpread({}, deduction.value), {}, {
          amount: value
        }));
      }
    });
    const computedFundsReceived = computed({
      get() {
        return deduction.value.fundsReceived ? deduction.value.fundsReceived.substring(0, 10) : "";
      },
      set(value) {
        emit("save", _objectSpread(_objectSpread({}, deduction.value), {}, {
          fundsReceived: value
        }));
      }
    });
    const computedDescription = computed({
      get() {
        return deduction.value.description;
      },
      set(value) {
        emit("save", _objectSpread(_objectSpread({}, deduction.value), {}, {
          description: value
        }));
      }
    });
    const handleRemove = () => emit("remove");
    return {
      // data
      deductionTypeOptions,
      fundsReceivedDateMax,
      // computed
      computedType,
      computedAmount,
      computedFundsReceived,
      computedDescription,
      // methods
      handleRemove
    };
  }
});